import { render } from "./LoadingDashboard.vue?vue&type=template&id=518b18d9&scoped=true"
import script from "./LoadingDashboard.vue?vue&type=script&lang=js"
export * from "./LoadingDashboard.vue?vue&type=script&lang=js"

import "./LoadingDashboard.vue?vue&type=style&index=0&id=518b18d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518b18d9"]])

export default __exports__